<template>
  <section>
    <div class="content_bg">
      <div class="content">
        <div>
          <Caption :label="label"></Caption>
        </div>

        <div class="filters" v-if="availableTags.length">
          <div class="filter_tags">
            <span
              class="filter_tag"
              :class="{ active: selectedTags.length === 0 }"
              @click="clearTags"
            >
              #전체
            </span>
            <span
              v-for="tag in availableTags"
              :key="tag"
              class="filter_tag"
              :class="{ active: isSelected(tag) }"
              @click="toggleTag(tag)"
            >
              #{{ tag }}
            </span>
          </div>
        </div>
        <ul>
          <li v-for="m of filteredList" :key="m.id">
            <ReferenceItem
              :id="m.id"
              :image="m.image"
              :text1="m.name"
              :text2="m.sub_text"
              :text3="m.desc"
              :tag_list="m.tag_list"
              :start_date="m.start_date"
            />
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>
  
<script>
import Caption from "./Caption.vue";
import CaptionGreen from "./CaptionGreen.vue";
import CaptionWhite from "./CaptionWhite.vue";
import ReferenceItem from "./ReferenceItem.vue";
import client from "../client/client";

export default {
  props: ["label"],
  components: {
    Caption,
    CaptionGreen,
    CaptionWhite,
    ReferenceItem,
  },
  mounted() {
    let url = "/api/portfolio/list"

    client
      .get(url)
      .then((res) => {
        this.list = res.list;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  data() {
    return {
      list: [],
      selectedTags: [],
    };
  },
  computed: {
    availableTags() {
      const tagSet = new Set();
      this.list.forEach(item => {
        (item.tag_list || []).forEach(t => {
          if (t && t.tag) tagSet.add(t.tag);
        });
      });
      return Array.from(tagSet);
    },
    filteredList() {
      if (!this.selectedTags.length) return this.list;
      const selected = new Set(this.selectedTags);
      return this.list.filter(item => {
        const itemTags = (item.tag_list || [])
          .map(t => (t && t.tag) ? t.tag : null)
          .filter(Boolean);
        return itemTags.some(tag => selected.has(tag));
      });
    },
  },
  methods: {
    isSelected(tag) {
      return this.selectedTags.includes(tag);
    },
    toggleTag(tag) {
      if (this.isSelected(tag)) {
        this.selectedTags = this.selectedTags.filter(t => t !== tag);
      } else {
        this.selectedTags = [...this.selectedTags, tag];
      }
    },
    clearTags() {
      this.selectedTags = [];
    },
  },
};
</script>
  
<style scoped>
.content_bg {
  display: flex;
  justify-content: center;
  width: 100vw;
  height: fit-content;
  position: relative;
  overflow: hidden;
  padding-top: 100px;
  padding-bottom: 100px;
  background-color: #f5f8fa;
}

.content {
  width: 1140px;
  max-width: 1140px;
  text-align: center;
}

.filters {
  margin-top: 24px;
}

.filter_tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}

.filter_tag {
  display: inline-flex;
  align-items: center;
  padding: 8px 12px;
  color: #495057;
  border-radius: 9999px;
  font-weight: 600;
  font-size: 14px;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  user-select: none;
  transition: all 0.15s ease-in-out;
}

.filter_tag.active {
  background-color: #d0ebff;
  color: #1864ab;
}

ul {
  margin-top: 40px;
  width: 100%;
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
  padding:0;
}
li:not(:last-child) {
  margin-right: 25px;
  margin-bottom: 25px;
}

ul li {
  display: inline-block;
}

@media screen and (max-width: 1440px) {
  .content_bg {
    padding-left: 40px;
    padding-right: 40px;
    justify-content: center;
    width: 100vw;
    height: fit-content;
    position: relative;
    overflow: hidden;
    background-color: #f5f8fa;
  }

  .content {
    width: 100vw;
    padding-left: 0px;
    text-align: center;
  }

  ul {
    text-align: center; 
    display: flex; 
    justify-content: center;
    width: fit-content;
    height: fit-content;
    list-style-type: none;
    overflow: hidden;
    overflow-y: scroll;
    padding-inline-start: 0px;
  }

  li:not(:last-child) {
    margin-right: 0px;
    margin-bottom: 15px;
  }

  ul li {
    display: block;
  }
}
</style>
  